var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "announcement-list-skeleton pb-4 mb-6" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "skeleton-items pl-5 pt-2" },
      _vm._l(3, function (i) {
        return _c("div", { key: i, staticClass: "skeleton-item" }, [
          _c("div", { staticClass: "skeleton-bullet" }),
          _vm._v(" "),
          _c("div", { staticClass: "skeleton-text skeleton-text--link" }),
          _vm._v(" "),
          _c("div", { staticClass: "skeleton-text skeleton-text--date" }),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "skeleton-header" }, [
      _c("div", { staticClass: "skeleton-icon" }),
      _vm._v(" "),
      _c("div", { staticClass: "skeleton-text skeleton-text--header" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }